const PACKAGES = [
  {
    name: "Essentials",
    desc: "Ideal for agents who need the MLS basics and nothing more.",
    price: "$325",
    items: ["Interior Photos", "Exterior Photos", "Aerial Photos", "Simple Floor Plan"],
    featured: false,
  },
  {
    name: "Social",
    desc: "Our most popular package — multiple pieces of content optimised for social media.",
    price: "$725",
    items: [
      "Interior Photos",
      "Exterior Photos",
      "Aerial Photos",
      "Agent Brand Reel",
      "Teaser Video",
      "Video Carousel",
    ],
    featured: true,
  },
  {
    name: "Legacy",
    desc: "A robust package with a smart blend of content and digital assets.",
    price: "$825",
    items: [
      "Interior Photos",
      "Exterior Photos",
      "Aerial Photos",
      "Video Property Tour",
      "Matterport 3D",
    ],
    featured: false,
  },
  {
    name: "Cinematic",
    desc: "Our top tier listing package — a customizable Cinematic Tour, premium listing photographs, and editorial style photographs.",
    price: "$1,450",
    items: [
      "Cinematic Tour",
      "Premium Interior, Exterior & Aerial Photographs",
      "Editorial Style Photographs",
    ],
    featured: false,
    note: "Not booked like standard content — request via our interest form and we'll get back to you same day.",
    link: "https://daily-antlion-6c4.notion.site/319646a47db580f58192f9e11439d750?pvs=105",
    ctaLabel: "Request this package",
  },
];

export default function Packages() {
  return (
    <section
      id="packages"
      data-testid="packages-section"
      className="py-20 md:py-32 border-t border-black/10 bg-[#f6f6f4]"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 mb-12">
          <div className="col-span-12 md:col-span-3">
            <span className="overline">04 — Packages</span>
          </div>
          <div className="col-span-12 md:col-span-9">
            <h2 className="font-serif-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-[-0.01em] max-w-4xl">
              Simple <span className="italic-display text-[#c9a878]">packages.</span>
              <br className="hidden md:block" /> A la carte pricing available.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-black/10 border border-black/10">
          {PACKAGES.map((p) => (
            <article
              key={p.name}
              data-testid={`package-${p.name.toLowerCase()}`}
              className={`relative bg-[#ffffff] p-8 md:p-10 flex flex-col ${
                p.featured ? "ring-2 ring-[#c9a878] z-10" : ""
              }`}
            >
              {p.featured && (
                <span className="absolute top-4 right-4 overline text-[#c9a878]">
                  ★ Most popular
                </span>
              )}
              <h3 className="font-serif-display text-3xl md:text-4xl">
                {p.name}
              </h3>
              <p className="mt-3 text-[14px] leading-[1.6] text-[#5a6470] min-h-[64px]">
                {p.desc}
              </p>

              <ul className="mt-6 mb-8 space-y-2 text-[14px] text-[#000000]">
                {p.items.map((i) => (
                  <li key={i} className="flex items-start gap-3 border-b border-black/5 pb-2">
                    <span className="text-[#c9a878]">/</span>
                    <span>{i}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-auto">
                <span className="overline block mb-1">Starting at</span>
                <div className="flex items-baseline gap-2">
                  <span className="font-serif-display text-5xl md:text-6xl leading-none">
                    {p.price}
                  </span>
                </div>
                <span className="overline mt-2 block">Based on square footage</span>
                {p.note && (
                  <p className="mt-3 text-[12px] leading-[1.6] text-[#5a6470]">
                    {p.note}
                  </p>
                )}
                <a
                  href={p.link || "https://portal.structuremedia.me/book"}
                  target={p.link && p.link.startsWith("#") ? undefined : "_blank"}
                  rel={p.link && p.link.startsWith("#") ? undefined : "noopener noreferrer"}
                  data-testid={`book-${p.name.toLowerCase()}`}
                  className="mt-6 inline-flex items-center justify-between w-full bg-[#000000] text-[#ffffff] px-5 py-3 text-[11px] tracking-[0.22em] uppercase font-medium hover:bg-[#c9a878] hover:text-black transition-colors duration-300"
                >
                  {p.ctaLabel || "Book now"} <span>→</span>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
